import { Component, OnInit, OnChanges, HostListener, ElementRef, Input, OnDestroy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { StaffsHelpbuttonService } from 'src/app/services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-helpbutton-staff-info-card',
  templateUrl: './helpbutton-staff-info-card.component.html',
  styleUrls: ['./helpbutton-staff-info-card.component.scss']
})
export class HelpbuttonStaffInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() staffInfo;
  editingLocked: boolean;
  centerInternalId: string;
  centerList: CenterLite[];
  userImage;
  updateStaffInfoSubscription: Subscription;
  basicDataForm = new FormGroup({
    staffEmail: new FormControl({value: null, disabled: true}),
    staffFirstname: new FormControl({value: null, disabled: true}),
    staffLastname: new FormControl({value: null, disabled: true}),
    active: new FormControl({ value: false, disabled: true }),
    staffSelectedCenter: new FormControl({ value: null, disabled: true })
  });

  constructor(private eRef: ElementRef,
              private userStorageService: UserStorageService,
              private staffsService: StaffsHelpbuttonService,
              private snackBarService: SnackBarService) {
                this.editingLocked = true;
              }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  ngOnChanges() {
    if (this.staffInfo) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.staffInfo && !this.editingLocked) {
            this.resetForm();
            this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
        this.submitForm();
        this.lockEdition();
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateStaffInfoSubscription = this.staffsService.updateStaff(this.staffInfo.InternalId, this.userImage, this.basicDataForm.get('active').value, this.basicDataForm.get('staffEmail').value, this.basicDataForm.get('staffFirstname').value, this.basicDataForm.get('staffLastname').value, this.basicDataForm.get('staffSelectedCenter').value.InternalId).subscribe(
        (res) => {
          this.editingLocked = true;
          this.staffsService.refreshStaff();
          this.snackBarService.open(res['message'], 'success');
        },
        (error) => {
          this.snackBarService.open(error['error'], 'error');
          this.staffsService.refreshStaff();
        }
      );
    } else {
      this.snackBarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('staffEmail').valid) {
      return 'helpbutton-page.snackbar messages.email staff error';
    } else if (!this.basicDataForm.get('staffFirstname').valid) {
      return 'helpbutton-page.snackbar messages.firstname staff error';
    } else if (!this.basicDataForm.get('staffLastname').valid) {
      return 'helpbutton-page.snackbar messages.lastname staff error';
    } else if (!this.basicDataForm.get('staffSelectedCenter').valid) {
      return 'helpbutton-page.snackbar messages.selected center staff error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.staffInfo.Active,
      staffEmail: this.staffInfo.Email,
      staffFirstname: this.staffInfo.Firstname,
      staffLastname: this.staffInfo.Lastname,
      staffSelectedCenter: this.setSelectedCenter()
    });
  }

  private unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('staffEmail').enable();
    this.basicDataForm.get('staffFirstname').enable();
    this.basicDataForm.get('staffLastname').enable();
    this.basicDataForm.get('staffSelectedCenter').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('staffEmail').disable();
    this.basicDataForm.get('staffFirstname').disable();
    this.basicDataForm.get('staffLastname').disable();
    this.basicDataForm.get('staffSelectedCenter').disable();
    this.editingLocked = true;
  }
  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  public setSelectedCenter() {
    if (this.staffInfo && this.centerList  && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.staffInfo.CenterInternalId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  ngOnDestroy() {
    if (this.updateStaffInfoSubscription) { this.updateStaffInfoSubscription.unsubscribe(); }

  }
}
